import type { CustomCellRendererProps } from "ag-grid-react";
import type { UID } from "src/types";
import Users from "../Users";
import { MembersContainer } from "./styles";

interface MembersCellRendererProps extends CustomCellRendererProps {
  value: Array<UID>;
}

export const MembersCellRenderer = ({
  value,
}: MembersCellRendererProps): React.ReactElement => {
  return (
    <MembersContainer>
      <Users users={value ?? []} />
    </MembersContainer>
  );
};
